(function () {
var WIDGET_SELECTOR = '#rebuy-widget-291683';
var TARGET_STEP_INDEX = 2; // 3rd step
var REQUIRED_LIQUID_COUNT = 4;
var LIQUID_DISPLAY_PRICE_TEXT = '£2.50';
var DISPLAY_ADJUSTMENT_CENTS = 355; // £3.55
var scheduled = false;
var started = false;
function toCents(value) {
if (value === null || value === undefined) return 0;
var cleaned = String(value).replace(/[^0-9.\-]/g, '');
var number = Number(cleaned);
if (!isFinite(number)) return 0;
return Math.round(number * 100);
}
function money(cents) {
return '£' + (Math.max(cents, 0) / 100).toFixed(2);
}
function clearVisualPrice(element) {
if (!element) return;
element.classList.remove('vsb-visual-price-target');
element.classList.remove('vsb-visual-savings');
element.removeAttribute('data-vsb-visual-price');
}
function clearVisualCompare(element) {
if (!element) return;
element.classList.remove('vsb-visual-compare-target');
element.removeAttribute('data-vsb-visual-price');
}
function removeGeneratedCompare(container) {
if (!container) return;
container.querySelectorAll('.vsb-generated-compare').forEach(function (el) {
el.remove();
});
}
function setVisualPrice(element, label, extraClass) {
if (!element || !label) return;
element.classList.add('vsb-visual-price-target');
if (extraClass) {
element.classList.add(extraClass);
}
element.setAttribute('data-vsb-visual-price', label);
}
function setVisualCompare(element, label) {
if (!element || !label) return;
element.classList.add('vsb-visual-compare-target');
element.setAttribute('data-vsb-visual-price', label);
}
function addGeneratedCompare(container, afterElement, label) {
if (!container || !afterElement || !label) return;
removeGeneratedCompare(container);
var compare = document.createElement('span');
compare.className = 'vsb-generated-compare';
compare.setAttribute('data-vsb-visual-price', label);
afterElement.insertAdjacentElement('afterend', compare);
}
function findMainPrice(container) {
if (!container) return null;
return container.querySelector(
'.rebuy-money.sale, .rebuy-money:not(.compare-at)'
);
}
function findComparePrice(container) {
if (!container) return null;
return container.querySelector('.rebuy-money.compare-at');
}
function getLiquidHolderSlots(widget) {
var holders = Array.prototype.slice.call(
widget.querySelectorAll('.rebuy-bundle-builder__product-holder')
);
return holders.slice(-REQUIRED_LIQUID_COUNT);
}
function getSelectedLiquidCount(widget) {
return getLiquidHolderSlots(widget).filter(function (holder) {
return holder.querySelector('.rebuy-bundle-builder__product-holder-data');
}).length;
}
function allFourLiquidsSelected(widget) {
return getSelectedLiquidCount(widget) >= REQUIRED_LIQUID_COUNT;
}
function selectedBundleCount(widget) {
return widget.querySelectorAll('.rebuy-bundle-builder__product-holder-data').length;
}
function updateStepProgress(widget) {
var wrap = widget.querySelector('.rebuy-bundle-builder__group-container-progress-bar');
if (!wrap) return;
var labels = ['Kit', 'Pods', '', '', '', ''];
var dots = ['1', '2', '3', '4', '5', '6'];
var progress = wrap.querySelector('.vsb-step-progress');
if (!progress) {
var html = '<div class="vsb-step-progress"><div class="vsb-step-progress__rail"><span class="vsb-step-progress__fill"></span></div><div class="vsb-step-progress__steps">';
labels.forEach(function (label, index) {
html += '<div class="vsb-step-progress__step" data-vsb-step="' + (index + 1) + '"><span class="vsb-step-progress__dot">' + dots[index] + '</span><span class="vsb-step-progress__label">' + label + '</span></div>';
});
html += '</div><div class="vsb-step-progress__liquid-label">Liquids</div></div>';
wrap.insertAdjacentHTML('afterbegin', html);
progress = wrap.querySelector('.vsb-step-progress');
}
var count = Math.min(selectedBundleCount(widget), labels.length);
var group = widget.querySelector('.rebuy-bundle-builder__group-container');
if (group) group.classList.toggle('vsb-has-products', count > 0);
var fill = count <= 1 ? 0 : ((count - 1) / (labels.length - 1)) * 100;
progress.querySelector('.vsb-step-progress__fill').style.width = fill + '%';
progress.querySelectorAll('.vsb-step-progress__step').forEach(function (step, index) {
step.classList.toggle('is-complete', count >= index + 1);
});
}
function getCleanMoneyText(element) {
if (!element) return '';
var clone = element.cloneNode(true);
clone.querySelectorAll('.sr-only, script, style').forEach(function (hidden) {
hidden.remove();
});
var text = clone.textContent ? clone.textContent.trim() : '';
var moneyMatches = text.match(/(?:£|\$|€)\s*\d+(?:[.,]\d{1,2})?/g);
if (moneyMatches && moneyMatches.length) {
return moneyMatches[moneyMatches.length - 1].replace(/\s+/g, '');
}
return text;
}
function originalPriceText(priceBlock, mainPrice, comparePrice) {
var compareText = getCleanMoneyText(comparePrice);
if (compareText) return compareText;
var mainText = getCleanMoneyText(mainPrice);
if (mainText) return mainText;
return '£3.99';
}
function clearLiquidGridPrices(widget) {
var step = widget.querySelector('.rebuy-product-grid__step-' + TARGET_STEP_INDEX);
if (!step) return;
step.querySelectorAll('.rebuy-product-price').forEach(function (priceBlock) {
clearVisualPrice(findMainPrice(priceBlock));
clearVisualCompare(findComparePrice(priceBlock));
removeGeneratedCompare(priceBlock);
});
}
function applyLiquidGridPrices(widget) {
var step = widget.querySelector('.rebuy-product-grid__step-' + TARGET_STEP_INDEX);
if (!step) return;
step.querySelectorAll('.rebuy-product-price').forEach(function (priceBlock) {
var mainPrice = findMainPrice(priceBlock);
var comparePrice = findComparePrice(priceBlock);
var original = originalPriceText(priceBlock, mainPrice, comparePrice);
setVisualPrice(mainPrice, LIQUID_DISPLAY_PRICE_TEXT);
if (comparePrice) {
setVisualCompare(comparePrice, original);
} else {
addGeneratedCompare(priceBlock, mainPrice, original);
}
});
}
function clearSelectedHolderLiquidPrices(widget) {
getLiquidHolderSlots(widget).forEach(function (holder) {
var priceBlock = holder.querySelector(
'.rebuy-bundle-builder__product-holder-info-price'
);
clearVisualPrice(findMainPrice(priceBlock));
clearVisualCompare(findComparePrice(priceBlock));
removeGeneratedCompare(priceBlock);
});
}
function applySelectedHolderLiquidPrices(widget) {
getLiquidHolderSlots(widget).forEach(function (holder) {
var selectedData = holder.querySelector('.rebuy-bundle-builder__product-holder-data');
if (!selectedData) return;
var priceBlock = selectedData.querySelector(
'.rebuy-bundle-builder__product-holder-info-price'
);
var mainPrice = findMainPrice(priceBlock);
var comparePrice = findComparePrice(priceBlock);
var original = originalPriceText(priceBlock, mainPrice, comparePrice);
setVisualPrice(mainPrice, LIQUID_DISPLAY_PRICE_TEXT);
if (comparePrice) {
setVisualCompare(comparePrice, original);
} else {
addGeneratedCompare(priceBlock, mainPrice, original);
}
});
}
function clearSavingsAdjustment(widget) {
var savings = widget.querySelector(
'.rebuy-bundle-builder__total-savings-amount'
);
clearVisualPrice(savings);
}
function applySavingsAdjustment(widget) {
var savings = widget.querySelector(
'.rebuy-bundle-builder__total-savings-amount'
);
if (!savings) return;
var realSavingsCents = toCents(savings.textContent);
if (realSavingsCents <= 0) return;
setVisualPrice(
savings,
money(realSavingsCents + DISPLAY_ADJUSTMENT_CENTS),
'vsb-visual-savings'
);
}
function clearSubtotalAdjustment(widget) {
var totalSelectors = [
'.rebuy-bundle-builder__action-box-price .rebuy-money.sale',
'.rebuy-bundle-builder__group-container-action .rebuy-money.sale'
];
totalSelectors.forEach(function (selector) {
widget.querySelectorAll(selector).forEach(function (total) {
clearVisualPrice(total);
});
});
}
function applySubtotalAdjustment(widget) {
var totalSelectors = [
'.rebuy-bundle-builder__action-box-price .rebuy-money.sale',
'.rebuy-bundle-builder__group-container-action .rebuy-money.sale'
];
totalSelectors.forEach(function (selector) {
widget.querySelectorAll(selector).forEach(function (total) {
var realTotalCents = toCents(total.textContent);
if (realTotalCents <= DISPLAY_ADJUSTMENT_CENTS) return;
setVisualPrice(
total,
money(realTotalCents - DISPLAY_ADJUSTMENT_CENTS)
);
});
});
}
function updateVisualOnlyPricing() {
var widget = document.querySelector(WIDGET_SELECTOR);
if (!widget) return;
updateStepProgress(widget);
var completed = allFourLiquidsSelected(widget);
if (!completed) {
clearLiquidGridPrices(widget);
clearSelectedHolderLiquidPrices(widget);
clearSavingsAdjustment(widget);
clearSubtotalAdjustment(widget);
return;
}
applyLiquidGridPrices(widget);
applySelectedHolderLiquidPrices(widget);
applySavingsAdjustment(widget);
applySubtotalAdjustment(widget);
}
function scheduleUpdate() {
if (scheduled) return;
scheduled = true;
window.requestAnimationFrame(function () {
scheduled = false;
updateVisualOnlyPricing();
});
}
function startVisualOnlyPricing() {
var widget = document.querySelector(WIDGET_SELECTOR);
if (!widget) {
setTimeout(startVisualOnlyPricing, 300);
return;
}
if (started) {
updateVisualOnlyPricing();
return;
}
started = true;
updateVisualOnlyPricing();
var observer = new MutationObserver(function () {
scheduleUpdate();
});
observer.observe(widget, {
childList: true,
subtree: true,
characterData: true
});
document.addEventListener('click', function (event) {
if (!event.target.closest(WIDGET_SELECTOR)) return;
setTimeout(updateVisualOnlyPricing, 120);
setTimeout(updateVisualOnlyPricing, 650);
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', startVisualOnlyPricing);
} else {
startVisualOnlyPricing();
}
setTimeout(startVisualOnlyPricing, 800);
})();
